import ResourcesCollectionProto from "./resources-collection-proto"
import ProjectUpdate from "../../../app/home/notifications/model/models/project/project-update"
import Resources from "../resources";

export default class ProjectUpdatesResourcesCollection extends ResourcesCollectionProto {
    constructor(resources:Resources, data: any[], options:any={}) {
        super(resources, data, ProjectUpdate, options)
    }
}